import { createFileRoute } from '@tanstack/react-router'
import { UserTokensPage } from '../../../../components/UserTokensPage'

export const Route = createFileRoute('/$org/users/$userUid/tokens')({
  component: UserTokensRoute,
  validateSearch: (search) => ({
    type: search.type as 'refresh_token' | 'pat' | undefined,
  }),
})

function UserTokensRoute() {
  const { org, userUid } = Route.useParams()
  const { type } = Route.useSearch()
  return <UserTokensPage orgCode={org} userUid={userUid} tokenType={type} />
}